import React, {useEffect, useRef, useState} from 'react';
import {
    checkNull,
    checkNullArr,
    checkNullJson,
    checkNullStr,
    getArrLen,
    getJsonValue,
    getDefStr,
    isBoolTrue,
    populateArr,
    printError,
    printLog,
    randomInt,
    randomStr
} from '../utils/ReactUtils';

/**
 * Create a tab-layout that has tabs in the left and teb-content in the right.
 *
 * @param onChange Callback to be called when a tab is selected/changed and contains: event, index, title, subtitle, tabId
 */
const TabLayout = React.memo(({
                                  className = "",
                                  contentWrapperClass = "",
                                  tabClassName = "",
                                  tabsWrapperClassName = "",
                                  contentClassName = "",
                                  tabsHeaderClassName = "",
                                  activeTabIndexClass = "active",
                                  transitionVariant = "sm",
                                  titleClassName = "",
                                  subtitleClassName = "",
                                  iconClassName = "",

                                  tabHeader = "",
                                  tabHeaderAt = "center",
                                  tabsBg = "gray",
                                  contentBg = "",
                                  taggedSubtitle = false,
                                  retainContentInDomOnTabChange = false,
                                  pushUrlParam = false,
                                  urlParamKey = 'param',
                                  urlParamValueKey = 'paramValue',
                                  tabsWidth = 20,
                                  contentWidth = 80,
                                  tabTextAt = "center",
                                  tabTextVertAt = "center",
                                  divColor = "transparent",
                                  scrollVariant = "dark",
                                  borderVariant = "danger",
                                  variant = "primary",
                                  reverseVariant = "white",
                                  activeBorder = true,
                                  showDivider = true,
                                  arrows = true,
                                  scrolledContent = true,
                                  defTabIndex = 0,
                                  subtitleWidth,
                                  subtitleHeight,
                                  subtitleFontSize,
                                  trailedTab = false,
                                  tabFontSize = "16px",
                                  tabTitleWidth = "80px",
                                  tabsMinWidth = 5,
                                  contentMinWidth = 20,
                                  headerContent,

                                  style = {},
                                  tabStyle = {},
                                  contentStyle = {},
                                  contentWrapperStyle = {},
                                  tabsWrapperStyle = {},
                                  tabsHeaderStyle = {},
                                  titleStyle = {},
                                  subtitleStyle = {},
                                  iconStyle = {},
                                  wrapperStyle = {},

                                  iconSize = "10px",

                                  height = "auto",
                                  children = [],
                                  content,
                                  onChange//returns e, index, title, subtitle
                              }) => {
    const TAG = "TabLayout";

    const [activeTabIndex, setActiveTabIndex] = useState(defTabIndex);
    const [tabActiveData, setTabActiveData] = useState({name: null, active: false});
    const [tabHoverData, setTabHoverData] = useState({name: null, active: false});
    const [tabPressData, setTabPressData] = useState({name: null, active: false});
    const [tabIds, setTabIds] = useState([]);

    const tabsParentRef = useRef([]);
    const tabItemRefs = useRef([]);

    const [isUrlParamsSet, setIsUrlParamsSet] = useState(false);
    const [viewHeight, setViewHeight] = useState(height);
    const [tabWidthPercent, setTabWidthPercent] = useState(tabsWidth + '%');
    const [contentWidthPercent, setContentWidthPercent] = useState(contentWidth + '%');
    const [dragging, setDragging] = useState(false);

    const [dividerPosition, setDividerPosition] = useState(30);

    useEffect(() => {
        setViewHeight(height);

        //change height to auto by calculating the heights of it's children
        if (height === "auto") {
            try {
                const children = tabsParentRef.current.children;
                let totalHeight = 0;
                for (let i = 0; i < children.length; i++) {
                    // totalHeight += children[i].offsetHeight + children.paddingTop + children.paddingBottom;
                    totalHeight += children[i].offsetHeight;
                }
                setViewHeight(totalHeight + 50 + "px");
                // tabsParentRef.current.style.height = totalHeight + "px";
            } catch (e) {
                logErr(e);
            }
        }
    }, [height]);

    useEffect(() => {
        setActiveTabIndex(defTabIndex);
    }, [defTabIndex]);

    useEffect(() => {
        setActiveTabIndex(defTabIndex);
        try {
            tabItemRefs.current[defTabIndex].click();
            tabItemRefs.current[defTabIndex].focus();
        } catch (error) {
            logErr('useEffect.defTabIndex.error:', error);
        }
    }, [defTabIndex]);
    // useEffect(() => {
    //     if (isBoolTrue(pushUrlParam) && !isUrlParamsSet) {
    //         pushCurrTabUrlParam(getArrIndexValue(children, defTabIndex));
    //         setIsUrlParamsSet(true);
    //     }
    // }, [children, defTabIndex, pushUrlParam, urlParamKey, urlParamValueKey]);


    useEffect(() => {
        setTabWidthPercent(tabsWidth + "%");
        setDividerPosition(tabsWidth);
    }, [tabsWidth]);

    useEffect(() => {
        setContentWidthPercent(contentWidth + "%")
    }, [contentWidth]);

    useEffect(() => {
        setTabIds(populateArr(tabIds, randomStr(randomInt(10, 20)), getArrLen(children)));
    }, [children]);

    const dividerRef = useRef();
    const handleMouseMove = e => {
        try {
            if (!dragging) return;
            const borderRect = dividerRef.current.getBoundingClientRect();
            const borderX = borderRect.x + borderRect.width / 2;
            const dragDistance = e.clientX - borderX;

            setTabWidthPercent(prevWidth => {
                const newWidth = parseFloat(prevWidth) + dragDistance;
                return `${newWidth}%`;
            });
            setContentWidthPercent(prevWidth => {
                const newWidth = parseFloat(prevWidth) - dragDistance;
                return `${newWidth}%`;
            });
        } catch (e) {
            logErr(e);
        }
    };

    const handleDivMouseUp = () => {
        setDragging(false);
        document.body.style.cursor = "auto";
        document.body.style.userSelect = "auto";
    };
    const handleDivMouseDown = (e) => {
        // event.preventDefault();
        setDragging(true);
        document.body.style.cursor = "col-resize";
        document.body.style.userSelect = "none";
        // log("handleDivMouseDown called")
    };

    const handleDragStart = (e) => {
        handleDivMouseDown(e)
        // e.preventDefault();
        // setDragging(true);
        // document.body.style.cursor = "col-resize";
        // document.body.style.userSelect = "none";
        // log("handleDragStart called")
    };

    const handleDragMove = (e) => {
        try {
            if (!dragging) {
                return;
            }
            const dividerElement = dividerRef.current;
            const containerElement = dividerElement.parentElement;
            const containerRect = containerElement.getBoundingClientRect();
            const containerWidth = containerRect.width;
            const containerLeft = containerRect.left;
            const mouseX = e.clientX || e.touches[0].clientX;
            const newPosition = (mouseX - containerLeft) / containerWidth * 100;
            setDividerPosition(newPosition);
        } catch (e) {
            logErr(e);
        }
    };

    const handleDragEnd = () => {
        setDragging(false);
    };

    const leftWidth = dividerPosition + '%';
    const rightWidth = (100 - dividerPosition) + '%';

    useEffect(() => {
        try {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleDivMouseUp);

            document.addEventListener('mousemove', handleDragMove);
            document.addEventListener('touchmove', handleDragMove);
            document.addEventListener('mouseup', handleDragEnd);
            document.addEventListener('touchend', handleDragEnd);

            return () => {
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleDivMouseUp);

                document.removeEventListener('mousemove', handleDragMove);
                document.removeEventListener('touchmove', handleDragMove);
                document.removeEventListener('mouseup', handleDragEnd);
                document.removeEventListener('touchend', handleDragEnd);
            };
        } catch (e) {
            logErr(e);
        }
    }, [dragging]);

    function pushCurrTabUrlParam(childIndexItem = {}) {
        const fun = 'pushCurrTabUrlParam:';
        if (isBoolTrue(pushUrlParam) && checkNullJson(childIndexItem) && checkNullArr(children) && checkNullStr(urlParamKey) && checkNullStr(urlParamValueKey)) {
            try {
                const paramValueToSet = childIndexItem[urlParamValueKey];
                const urlParams = new URLSearchParams(window.location.search);
                urlParams.set(urlParamKey, paramValueToSet);
                window.history.replaceState({}, '', window.location.pathname + '?' + urlParams.toString());
                log(fun, 'paramValueToSet:', paramValueToSet);
            } catch (error) {
                logErr(fun, 'error:', error);
            }
        }
    }

    function handleTabsKeyDown(e) {
        if (isBoolTrue(arrows)) {
            try {
                if (checkNullArr(children)) {
                    const tabSize = children.length;
                    if (e.key === "ArrowUp") {
                        e.preventDefault();
                        const activeIndex = (activeTabIndex - 1 + tabSize) % tabSize;
                        setActiveTabIndex(activeIndex);
                        setTabActiveData({name: getJsonValue(children[activeIndex], 'title'), active: true});
                        tabItemRefs.current[activeIndex].click();
                        tabItemRefs.current[activeIndex].focus();
                        pushCurrTabUrlParam(children[activeIndex]);
                    } else if (e.key === "ArrowDown") {
                        e.preventDefault();
                        const activeIndex = ((activeTabIndex + 1 + tabSize) % tabSize);
                        setTabActiveData({name: getJsonValue(children[activeIndex], 'title'), active: true});
                        setActiveTabIndex(activeIndex);
                        tabItemRefs.current[activeIndex].click();
                        tabItemRefs.current[activeIndex].focus();
                        pushCurrTabUrlParam(children[activeIndex]);
                    }
                }
            } catch (error) {
                logErr(error)
            }
        }
    }

    const handleTabClick = (e, index, title, subtitle) => {
        if (index != activeTabIndex) {
            setActiveTabIndex(index);
            setTabActiveData({name: title, active: true});
            // log( `handleTabClick=> index: ${index}, title: ${title}, subtitle: ${subtitle}`);
            if (checkNull(onChange)) onChange(e, index, title, subtitle);
            pushCurrTabUrlParam(children[index]);
        }
    };

    return (
        <div className={`tab-layout d-flex flex-nowrap df-row p-0 m-0 overflow-hidden transition  ${className}`}
             style={{...style}}
        >
            {/*tabs*/}
            <div
                ref={tabsParentRef}
                tabIndex="0"
                onKeyDown={handleTabsKeyDown}
                className={`tabs outline-none scroller scroller-y-auto scroll-${scrollVariant} 
                 w-${tabsWidth}x p-0 m-0 ${tabsWrapperClassName} bg-${tabsBg}`}
                style={{
                    width: tabWidthPercent,
                    minWidth: tabsMinWidth + '%',
                    viewHeight,
                    backgroundColor: tabsBg,
                    ...tabsWrapperStyle
                }}
            >

                {/*tab header*/}
                {checkNullStr(tabHeader) && <div className={`m-0 p-0 px-2 jc-${tabHeaderAt} ${tabsHeaderClassName}`}
                                                 style={{...tabsHeaderStyle}}>
                    {tabHeader}
                    {checkNull(headerContent) && headerContent}
                </div>}

                {/*tab-items*/}
                {checkNullArr(children) && children.map((item, index) => {
                    // const tabId = shuffleString(index + item.title + item.subtitle + index);
                    const tabId = index + item.title;
                    return <div
                        ref={(ref) => (tabItemRefs.current[index] = ref)}
                        key={index + tabId}
                        // key={tabId}
                        id={tabId}
                        tabIndex="-1"
                        style={{fontSize: tabFontSize, ...tabStyle}}
                        className={`tab ${isBoolTrue(activeBorder && index === activeTabIndex) ? 'active rounded-2' : 'borderless'} 
                        mx-0 my-0 m-0 p-0 px-0 
                        text-${tabTextAt} 
                        jc-${tabTextAt}  
                        al-${tabTextVertAt}
                         ${index === activeTabIndex ? activeTabIndexClass : ''} 
                        ${isBoolTrue(trailedTab) ? 'trailedx' : ''} 
                        border-${borderVariant}x
                        d-flex w-100 transition-${transitionVariant} select-none cursor-pointer
                         text-${variant}-hover text-${reverseVariant}-active text-${reverseVariant}-focus text-${variant} highlight-${variant}-hover highlight-${variant}-full-focus highlight-${variant}-full-visited highlight-${variant}-full-active border-none outline-none outline-none border-none
                        ${tabClassName}
                        ${getJsonValue(item, 'titleClassName', '')}
                         ${isBoolTrue(getJsonValue(item, 'disabled', false)) ? 'disable-item-xs' : ''}
                        `}
                        disabled={isBoolTrue(getJsonValue(item, 'disabled', false))}
                        onClick={(e) => handleTabClick(e, index, item.title, item.subtitle)}
                    >
                        {/*tab-text*/}
                        <span className={`w-100 d-flex fd-row overflow-hidden jc-between alx-${checkNullStr(item.subtitle) ? 'start' : 'center'}`}>
                            <span className={`w-auto d-flex fd-row overflow-hidden jc-start flex-nowrap al-center`}>
                                {/*icon*/}
                                {checkNullStr(getDefStr(item.iconClass, item.icon)) &&
                                    <i className={`p-0 m-0 mx-1 d-flex jc-center al-center ${getDefStr(item.iconClass, item.icon)} ${iconClassName}`}
                                       style={{
                                           fontSize: iconSize,
                                           ...iconStyle,
                                           ...checkNullJson(item.iconStyle) ? item.iconStyle : {}
                                       }}/>
                                }
                                {/*title*/}
                                <span
                                    className={`tab-text word-wrap overflow-wrap p-0 m-0 ${checkNullStr(item.subtitle) ? 'overflow-hidden' : 'w-100'} ${titleClassName}`}
                                    style={{minWidth: tabTitleWidth, ...titleStyle}}>
                                    {checkNullStr(item.renderTitle) ? item.renderTitle : item.title}
                                </span>
                            </span>

                            {/*subtitle*/}
                            {checkNullStr(item.subtitle) &&
                                <div
                                    className={`subtitle m-0 px-1 ${subtitleClassName} 
                                bg-${getJsonValue(item, 'subtitleBg', '')}
                                text-${getJsonValue(item, 'subtitleColor', '')}
                                ${getJsonValue(item, 'subtitleClassName', '')}
                                ${isBoolTrue(taggedSubtitle) ? 'p-1 circular d-flex jc-center align-items-center' : ''}
                                `}
                                    style={{
                                        width: isBoolTrue(taggedSubtitle) ? getDefStr(subtitleWidth, getJsonValue(item, 'subtitleWidth', '16px')) : "auto",
                                        height: isBoolTrue(taggedSubtitle) ? getDefStr(subtitleHeight, getJsonValue(item, 'subtitleHeight', '16px')) : "auto",
                                        fontSize: isBoolTrue(taggedSubtitle) ? getDefStr(subtitleFontSize, getJsonValue(item, 'subtitleFontSize', '10px')) : "inherit",
                                        ...subtitleStyle
                                    }}>
                                    {item.subtitle}
                                </div>}
                        </span>
                    </div>
                })}
            </div>
            {/*divider*/}
            {isBoolTrue(showDivider) && <div
                className={`p-0 m-0 cursor-col-resize highlight-border-primary-hover tl-divider`}
                ref={dividerRef}
                onMouseDown={handleDragStart}
                onTouchStart={handleDragStart}
                style={{height: viewHeight, borderRight: `2px solid ${divColor}`}}
            />}
            {/*drag button, visible on small screen*/}
            {/*<Button className={"p-2 mt-1 bg-primary-light"}*/}
            {/*        style={{marginLeft: "-15px"}}*/}
            {/*        hidden={true}*/}
            {/*        circular={true}*/}
            {/*        ref={dividerRef}*/}
            {/*        iconClass={"fa fa-arrows-h text-light"}*/}
            {/*        width={"30px"}*/}
            {/*        height={"30px"}*/}
            {/*        onMouseDown={handleDivMouseDown}*/}
            {/*    //     onMouseDown={handleDragStart}*/}
            {/*    //     onTouchStart={handleDragStart}*/}
            {/*/>*/}
            {/*content*/}
            <div
                // className={`tab-content ${isBoolTrue(scrolledContent) ? `scroller scroller-y-auto scroll-${scrollVariant}` : ''}
                className={`tab-content  
                w-${contentWidthPercent}x bg-${contentBg} p-0 m-0 transitionx ${contentClassName}`}
                style={{
                    width: contentWidthPercent,
                    minWidth: contentMinWidth + '%',
                    // height: viewHeight,
                    ...contentStyle
                }}
            >
                {checkNullArr(children) && children.map((item, index) => {
                    return isBoolTrue(retainContentInDomOnTabChange)
                        ? <div
                            className={`p-0 m-0 inner-content ${contentWrapperClass} ${isBoolTrue(getJsonValue(item, 'disabled', false)) ? 'disable-item-xs' : ''} ${isBoolTrue(scrolledContent) ? `scroller overflow-y-auto scroll-${scrollVariant}` : ''}  ${index === activeTabIndex ? 'active' : ''}`}
                            key={index + 'kk'}
                            style={{
                                display: (index === activeTabIndex) ? 'block' : 'none',
                                height: viewHeight,
                                ...contentWrapperStyle
                            }}
                            disabled={isBoolTrue(getJsonValue(item, 'disabled', false))}
                        >
                            {item.topContent && item.topContent}
                            {item.children}
                            {item.bottomContent && item.bottomContent}
                        </div>
                        : ((index === activeTabIndex) &&
                            <div
                                className={`p-0 m-0 inner-content ${contentWrapperClass} ${isBoolTrue(getJsonValue(item, 'disabled', false)) ? 'disable-item-xs' : ''} ${isBoolTrue(scrolledContent) ? `scroller overflow-y-auto scroll-${scrollVariant}` : ''}  ${index === activeTabIndex ? 'active' : ''}`}
                                disabled={isBoolTrue(getJsonValue(item, 'disabled', false))}
                                key={index + 'll'}
                                style={{
                                    height: viewHeight,
                                    ...contentWrapperStyle
                                }}
                            >
                                {item.topContent && item.topContent}
                                {item.children}
                                {item.bottomContent && item.bottomContent}
                            </div>)
                })}
            </div>
            {content}
        </div>
        // </div>
    );

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }
});

export default TabLayout;
